import { PLATFORM } from "aurelia-pal";
import {
  ConfiguresRouter,
  Router,
  RouteConfig,
  RouterConfiguration,
} from "aurelia-router";

export class AdminIndex implements ConfiguresRouter {
  router: Router;

  configureRouter(config: RouterConfiguration, router: Router) {
    config.map([
      {
        route: "",
        name: "empty",
        moduleId: PLATFORM.moduleName("./admin-empty"),
        title: "admin.title",
        settings: { needsRightOneOf: ["admin-read"] },
      },
      {
        route: "import",
        name: "import",
        moduleId: PLATFORM.moduleName("./import"),
        nav: true,
        title: "admin.import.title",
        settings: { needsRightOneOf: ["admin-write"] },
      },
      {
        route: "pumpentypen",
        name: "pumpentypen",
        moduleId: PLATFORM.moduleName("./pumpentypen"),
        nav: true,
        title: "admin.pumpentypen.title",
        settings: { needsRightOneOf: ["admin-read"] },
      },
      {
        route: "log",
        name: "log",
        moduleId: PLATFORM.moduleName("./log"),
        nav: true,
        title: "admin.log.title",
        settings: { needsRightOneOf: ["admin-read"] },
      },
      {
        route: "users",
        name: "users",
        moduleId: PLATFORM.moduleName("./users"),
        nav: true,
        title: "admin.users.title",
        settings: { needsRightOneOf: ["admin-read", "admin-write"] },
      },
      {
        route: "config",
        name: "config",
        moduleId: PLATFORM.moduleName("./config"),
        nav: true,
        title: "admin.config.title",
        settings: { needsRightOneOf: ["admin-read", "admin-write"] },
      },
      {
        route: "translations",
        name: "translations",
        moduleId: PLATFORM.moduleName("./translations"),
        nav: true,
        title: "admin.translations.title",
        settings: { needsRightOneOf: ["admin-read", "admin-write"] },
      },
      {
        route: "geometrie",
        name: "geometrie",
        moduleId: PLATFORM.moduleName("./geometrie"),
        nav: true,
        title: "admin.geometrie.title",
        settings: { needsRightOneOf: ["admin-read", "admin-write"] },
      },
      {
        route: "geometrie-matrix",
        name: "geometrie-matrix",
        moduleId: PLATFORM.moduleName("./geometrie-matrix"),
        nav: true,
        title: "admin.geometrie-matrix.title",
        settings: { needsRightOneOf: ["admin-read", "admin-write"] },
      },
    ] as RouteConfig[]);
    config.mapUnknownRoutes(PLATFORM.moduleName("../notfound"));

    this.router = router;
  }
}
